import React, { useEffect, useState } from 'react';
import useStateBackend from "../../hooks/useBackendStatus";
import styles from './WaitingPage.module.css';

const WaitingPage = () => {
    useStateBackend();

    return (
        <div className={styles.container}>
            <p className={styles.titleText}>{"Произошла ошибка"} </p>
            <p className={styles.mainText}> {"Нет связи с сервером, "}<br />
                {"проверьте своё интернет соединение."}</p>
        </div>
    );
}

export default WaitingPage;